import {
  DARK_THEME,
  DRAWER_TYPE,
  FIXED_DRAWER,
  MINI_DRAWER,
  SWITCH_LANGUAGE,
  THEME_COLOR,
  TOGGLE_COLLAPSED_NAV,
  WINDOW_WIDTH,
} from 'constants/ActionTypes';
import {
  AMBER,
  BLUE,
  CYAN,
  DARK_AMBER,
  DARK_BLUE,
  DARK_CYAN,
  DARK_DEEP_ORANGE,
  DARK_DEEP_PURPLE,
  DARK_GREEN,
  DARK_INDIGO,
  DARK_PINK,
  DEEP_ORANGE,
  DEEP_PURPLE,
  GREEN,
  INDIGO,
  PINK,
} from 'constants/ThemeColors';

const rltLocale = ['ar'];
export const initialSettings = {
  navCollapsed: false,
  drawerType: MINI_DRAWER,
  themeColor: DARK_PINK,
  darkTheme: false,
  width: $(window).width(),
  isDirectionRTL: false,
  locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
};

const settings = (state = initialSettings, action) => {
  switch (action.type) {

    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        navCollapsed: false,
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed,
      };
    case DRAWER_TYPE:
      return {
        ...state,
        drawerType: action.drawerType,
      };
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case THEME_COLOR:
      return {
        ...state,
        darkTheme: false,
        themeColor: action.color,
      };
    case DARK_THEME:
      return {
        ...state,
        darkTheme: !state.darkTheme,
      };
    case SWITCH_LANGUAGE:

      return {
        ...state,
        locale: action.payload,
        // isDirectionRTL: rltLocale.includes(action.payload.locale)

      };

    case 'SET_DEFAULT_THEME':
      return {
        navCollapsed: false,
        drawerType: MINI_DRAWER,
        themeColor: DARK_PINK,
        darkTheme: false,
        width: $(window).width(),
        isDirectionRTL: false,
        locale: {
          languageId: 'english',
          locale: 'en',
          name: 'English',
          icon: 'us',
        },
      };

    default:
      return state;
  }
};

export default settings;



// WEBPACK FOOTER //
// ./reducers/Settings.js